import React from 'react'
import { Field } from 'redux-form'
import { TextField, SelectField, Toggle } from '@foodsby/nutrient'
import { length, required, numericality } from 'redux-form-validators/lib'
import { noSpacesAllowed } from '../../util/validators'
import { getYear } from 'date-fns'

export const CreditCardDetail = ({ creditCards }) => {
  const months = [
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12'
  ]
  const yearStart = getYear(new Date())
  const years = Array(20)
    .fill()
    .map((_, i) => yearStart + i)
  return (
    <div
      className={
        creditCards && creditCards.length > 0 ? 'row segment-push' : 'row'
      }
    >
      <div className="col-xs-12 col-md-6 _lr-hide">
        <Field
          id="cc.number"
          name="cc.number"
          component={TextField}
          type="text"
          label="Credit Card Number *"
          maxLength="19"
          validate={[
            required({ msg: `Credit Card Number is required` }),
            numericality({
              msg: 'Credit Card Number must only contain numbers'
            }),
            length({
              min: 13,
              msg: {
                tooShort: `Credit Card Number is too short (minimum of {count, number} {count, plural, one {character} other {characters}})`
              }
            })
          ]}
        />
      </div>
      <div className="col-xs-12 col-md-2 _lr-hide">
        <Field
          id="cc.cvv"
          name="cc.cvv"
          component={TextField}
          type="text"
          label="CVV *"
          maxLength="4"
          validate={[
            required({ msg: `CVV is required` }),
            numericality({ msg: 'CCV must only contain numbers' }),
            length({
              min: 3,
              msg: {
                tooShort: `CVV is too short (minimum of {count, number} {count, plural, one {character} other {characters}})`
              }
            })
          ]}
        />
      </div>
      <div className="col-xs-12 col-md-4">
        <label htmlFor="expiry">Expiration Date *</label>
        <div className="row">
          <div className="col-md-6">
            <Field
              id="cc.expMonth"
              name="cc.expMonth"
              component={SelectField}
              validate={[required({ msg: `Expiration Month is required` })]}
            >
              {months.map((month, index) => {
                return (
                  <option key={month} value={index + 1}>
                    {month}
                  </option>
                )
              })}
            </Field>
          </div>
          <div className="col-md-6">
            <Field
              id="cc.expYear"
              name="cc.expYear"
              component={SelectField}
              validate={[required({ msg: `Expiration Year is required` })]}
            >
              {years.map(year => {
                return (
                  <option key={year} value={year}>
                    {year}
                  </option>
                )
              })}
            </Field>
          </div>
        </div>
      </div>
      <div className="col-xs-12 col-md-6">
        <Field
          id="firstName"
          name="firstName"
          component={TextField}
          type="text"
          label="First Name *"
          validate={[
            noSpacesAllowed,
            required({ msg: `First Name is required` }),
            length({ max: 35 })
          ]}
        />
      </div>
      <div className="col-xs-12 col-md-6">
        <Field
          id="lastName"
          name="lastName"
          component={TextField}
          type="text"
          label="Last Name *"
          validate={[
            noSpacesAllowed,
            required({ msg: `Last Name is required` }),
            length({ max: 35 })
          ]}
        />
      </div>
      <div className="col-xs-4">
        <Field
          id="zip"
          name="zip"
          component={TextField}
          type="number" // with the type being number for some reason the maxLength prop doesn't work, we can change it to text and it would work but then you could enter letters into the zip code box which i would think is less desired
          label="Zip Code*"
          validate={[
            numericality({ int: true }),
            required({ msg: `Zip Code is required` }),
            length({
              min: 5,
              max: 5,
              msg: {
                tooShort: `Zip Code is too short (minimum of 5 numbers)`,
                tooLong: `Zip Code is too long (maximum of 5 numbers)`
              }
            })
          ]}
        />
      </div>
      <div className="col-xs-6 col-xs-offset-2">
        <Field
          id="saveCard"
          name="saveCard"
          component={Toggle}
          label="Save this card for future use?"
          checkedLabel="Yes"
          uncheckedLabel="No"
        />
      </div>
    </div>
  )
}
export default CreditCardDetail
